/*
 * NOTE: We want to maintain this component level template as .ts file so we can add comments.
 */
export default {
  name: 'dashify:TrafficLightDoesntWork',
  title: 'TrafficLight - unused, we have a working version of TrafficLight component',
  owner: 'System',
  solution: '',
  tags: ['data', 'visualization', 'pie', 'donut'],
  createdAt: 'Sep 7, 2023, 10:14 AM',
  updatedAt: 'Oct 12, 2023, 09:03 AM',
  spec: {
    props: {
      // Non Highcharts-related API
      // we cannot feed all the data into the highcharts config; slices will all get colored as there is no option
      // to color the pie just with specific slice
      data: [],
      highchartsConfig: {},
    },
    defaults: {
      series: [
        {
          data: ['/${ $sort(props.data, function($l, $r) { $l.y < $r.y})[0] }'],
        },
      ],
      height: '160',
      chart: {
        type: 'pie',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: 'rgba(0,0,0,0)',
        style: {
          fontFamily: 'var(--typography-font-body)',
        },
        styledMode: false,
      },
      title: {
        verticalAlign: 'middle',
        widthAdjust: -80,
        y: 12,
        style: {
          color: '#B1B2B3',
          fontSize: 28,
          lineHeight: 33,
          weight: 500,
        },
      },
      subtitle: {
        verticalAlign: 'middle',
        widthAdjust: -80,
        y: 40,
        style: {
          color: '#B1B2B3',
          fontSize: 16,
          lineHeight: 19,
          weight: 500,
        },
      },
      plotOptions: {
        pie: {
          colors: ['/${ $sort(props.data, function($l, $r) { $l.y < $r.y})[0].color }'],
          // below following https://api.highcharts.com/highcharts/plotOptions.pie.borderWidth
          // in hope to get rid of the white border around slices but did not work
          borderColor: null,
          borderWidth: 0.5,
          size: 160,
          allowPointSelect: true,
          cursor: 'pointer',
          innerSize: '56.25%',
          crisp: true,
          dataLabels: {
            shadow: false,
            connectorShape: 'straight',
            enabled: false,
          },
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        useHTML: true,
        formatter: function (this: Highcharts.TooltipFormatterContextObject) {
          let tooltipContent = `<div style='width: 130px; height: 120px; border-radius: 6px; padding: 12px; background-color: #373C42;'>`;
          // tooltip does not quite work yet - various errors trying to access props.data here
          // we cannot pass all the data points in series as that will draw all the slices
          const series = this.series as Highcharts.Series;
          series.points.forEach((point: Highcharts.Point) => {
            tooltipContent += `<div style='display: flex; color: #FFFFFF; font-size: 11px; line-height: 18px; margin-bottom: 8px;'><span style='padding-left: 8px; font-weight: 400;'>${point.name}</span>: <span style='margin-left: auto; font-weight: 500;'>${point.y}</span></div>`;
          });
          tooltipContent += `</div>`;
          return tooltipContent;
        },
        padding: 0,
        borderWidth: 0,
        borderRadius: 6,
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    },
    view: [
      [
        'div',
        {
          '.': 'grow',
        },
        [['dashify:Highcharts', '/${ $defaultsDeep({}, props, props.highchartsConfig, defaults) }']],
      ],
    ],
  },
};
